import memoizeOne from 'memoize-one';
import _isEqual from 'lodash.isequal';

function getContext({
  state,
  actions
}) {
  return {
    state,
    actions
  };
}

function contextHasChanges([newArgs], [oldArgs]) {
  return _isEqual(getContext(newArgs), getContext(oldArgs));
}

export default memoizeOne(getContext, contextHasChanges);